import React from 'react';
import { connectToModel } from 'client/data/luckdragon/redux/react-binding';
import { bindToContent, CmsEntities } from 'client/data/models/cms';
import { getResearchArticleIndexPath } from 'site-modules/editorial/utils/content-path';
import { Best } from 'site-modules/editorial/pages/best/best';

function ResearchBestUI({ content = null }) {
  if (!content) {
    return null;
  }

  return <Best content={content} hasLinkWidget={content.id.includes('/car-leasing/monthly-199-lease-deals')} />;
}

ResearchBestUI.propTypes = {
  content: CmsEntities.Content,
};

export const ResearchBest = connectToModel(ResearchBestUI, {
  content: bindToContent(({ articleCategory, articleId, splat }) =>
    getResearchArticleIndexPath(articleCategory, articleId, splat)
  ),
});
